export function toIsoDate(date) {
  return date ? date.toISOString().split('T')[0] : '';
}

export function asDate(dateString) {
  return dateString ? new Date(dateString) : null;
}

export function asDateWithTimezone(dateString) {
  return dateString ? new Date(dateString).toLocaleString() + " (" + Intl.DateTimeFormat().resolvedOptions().timeZone + ")" : null;
}
